import {match} from 'ts-pattern';

import type {Nullish} from 'shared/web';

import {getCustomerInsightsBusinessCaseCategory} from './getCustomerInsightsBusinessCaseCategory';

export interface CustomerInsightsBusinessCasePricePermissions {
  canReadBusinessCasePurchaseTotalPrice: boolean;
  canReadBusinessCaseSaleTotalPrice: boolean;
}

export function canReadCustomerInsightsBusinessCasePrice(
  businessCaseType: string | Nullish,
  permissions: CustomerInsightsBusinessCasePricePermissions
) {
  const category = getCustomerInsightsBusinessCaseCategory(businessCaseType);

  return match(category)
    .with('sale', () => permissions.canReadBusinessCaseSaleTotalPrice)
    .with('purchase', () => permissions.canReadBusinessCasePurchaseTotalPrice)
    .otherwise(() => false);
}
